import React from 'react';
import './QRCodes.less';
import QRCodeTable from './QRCodeTable/QRCodeTable';

const QRCodes = () => (
  <QRCodeTable />
);

export default QRCodes;
